import React from 'react';
import Sidebar from '../components/Sidebar';
import { Outlet, useLocation } from 'react-router-dom'; // 1. Importei useLocation

const Layout = () => {
  const location = useLocation();

  // 2. Verifica se a rota atual é a dashboard (ajuste '/' se sua home for login)
  const isDashboard =
    location.pathname === '/' || location.pathname.includes('dashboard');

  return (
    // Mudei para h-screen e overflow-hidden para travar a rolagem geral e evitar barras duplas
    <div className="flex h-screen overflow-hidden bg-[#071426]">
      <Sidebar />
      <div className="flex flex-col flex-1 relative">
        {/* 3. AQUI ESTAVA O CULPADO: px-6 pb-6 bg-gray-100 */}
        <main
          className={`flex-1 ${
            isDashboard
              ? 'p-0 bg-[#071426] overflow-hidden' // Dashboard: Zero margem, fundo escuro
              : 'pt-0 px-6 pb-6 bg-gray-100 overflow-auto' // Outros: Margem normal, fundo cinza
          }`}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
